import type {
  AmbientScribeEventData,
  AmbientScribeEventName,
} from './constants/events';
import { EVENTS, WIDGET_EVENTS } from './constants/events';
import './polyfills';
import type {
  AmbientScribeContext,
  AmbientScribeWidgetConfig,
  Appointment,
} from './types';
import { AmbientScribeWidget } from './widget';
// Global type declarations are handled in src/types/window.d.ts

export type { LogLevel } from '@ptek/client-logger';
export { AmbientScribeWidget, EVENTS, WIDGET_EVENTS };
export type {
  AmbientScribeContext,
  AmbientScribeEventData,
  AmbientScribeEventName,
  AmbientScribeWidgetConfig,
  Appointment,
};
if (typeof window !== 'undefined') {
  window.AmbientScribeWidget = AmbientScribeWidget;
  window.AmbientScribeEvents = EVENTS;
}

export default AmbientScribeWidget;
